import SkeletonGroup from 'components/Skeleton/SkeletonGroup';

import SwitchGroupSkeleton from '../SwitchGroup/Skeleton';

const EmailAlertsSkeleton = () => (
  <SkeletonGroup items={6} skeleton={SwitchGroupSkeleton} />
);

export default EmailAlertsSkeleton;
